module.exports = __webpack_public_path__ + "static/img/c60.7618b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/c60.jpg
// module id = 5lMb
// module chunks = 0